var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header header-font"},[_c('font-awesome-icon',{attrs:{"icon":"calculator"}}),_c('span',[_vm._v(" "+_vm._s(_vm.$t("capitalGrowthChart")))])],1),_c('div',{staticClass:"card-body"},[_c('line-chart',{attrs:{"chart-data":_vm.chartdata1,"options":_vm.option1,"height":200,"width":200}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }